var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tip"},[_c('p',[_vm._v("Suggested tips is $10 per person per hour")]),_c('p',[_vm._v("If you have overly large/heavy items, or any single item over 200lbs, there may be extra charge, please let us know in advance.")])])
}]

export { render, staticRenderFns }